import React from "react";
import "./Footer.css";
import logoWhite from "../../assets/logo-white.svg";
import brandIcon from "../../assets/Brand_Main Icon.png";

const Footer = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="footer">
      <div className="footer__noise" />
      <div className="footer__glow" />

      <div className="footer__top">
        <div className="footer__brand">
          <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="footer__logo-btn">
            <img src={logoWhite} alt="Placify Innovative" className="footer__logo-img" />
          </button>
          <p className="footer__tagline">
            Your trusted partner for IT &amp; non-IT staffing, career counselling,
            and professional growth. Shaping careers globally.
          </p>
          <div className="footer__social">
            <a href="https://www.linkedin.com/company/placify-innovative/" target="_blank" rel="noopener noreferrer" className="footer__social-link">in</a>
            <a href="https://www.instagram.com/placifyinnovative/" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
              </svg>
            </a>
            <a href="mailto:support@placifyinnovative.com" className="footer__social-link" aria-label="Email">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer__links-grid">
          <div className="footer__col">
            <h5>Services</h5>
            {["Resume Enhancement","LinkedIn Optimization","Career Counselling","Technical Training","Job Placement"].map(s => (
              <button key={s} onClick={() => scrollTo("services")}>{s}</button>
            ))}
          </div>
          <div className="footer__col">
            <h5>Company</h5>
            {[["About Us","why"],["Our Process","process"],["Success Stories","testimonials"],["Contact Us","contact"]].map(([label, id]) => (
              <button key={id} onClick={() => scrollTo(id)}>{label}</button>
            ))}
          </div>
          <div className="footer__col">
            <h5>Contact</h5>
            <a href="mailto:support@placifyinnovative.com" className="footer__info">support@placifyinnovative.com</a>
            <a href="tel:+13612434345" className="footer__info">+1 (361)-243-4345</a>
            <span className="footer__info">Sheridan, Wyoming, 82801, US</span>
            <span className="footer__info">King Ave, Kingsville, Texas 78363, US</span>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-left">
          <img src={brandIcon} alt="" className="footer__icon" />
          <span>© 2026 Placify Innovative. All rights reserved.</span>
        </div>
        <span>Made with ♥ in USA & India</span>
      </div>
    </footer>
  );
};

export default Footer;
